import { generateSetChild, generateUpdateArrayChild } from '@/helpers/VuexHelpers'
import { service } from '@/service'
import { config } from '@/config'

export default {
	namespaced: true,
	state: {
		promotions: null,
	},
	actions: {
		async loadPromotions({ commit, dispatch }, { promotionCodes = [], accumulatorGroup = null } = {}) {
			const result = await service.loadFreeProductPromotions({ promotionCodes, accumulatorGroup })
			if (result?.promotions) {
				commit('setPromotions', { item: result.promotions })
			}
		},
		async applyPromotion({ commit }, { codes, contaoContentId, accumulatorGroup = null } = {}) {
			await service.generateFreeProductVoucher({ codes, contaoContentId, accumulatorGroup })
		},
	},
	getters: {
		promotions (state) {
			return state.promotions || []
		},
	},
	mutations: {
		setPromotions: generateSetChild("promotions"),
	}
}